import { render, staticRenderFns } from "./ModrEditAppr.vue?vue&type=template&id=03a8264c&scoped=true&"
import script from "./ModrEditAppr.vue?vue&type=script&lang=js&"
export * from "./ModrEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a8264c",
  null
  
)

export default component.exports